import React, { useState, useEffect, useRef } from 'react'
import questions from '../questions_data/questions';
import questions_chi from '../questions_data/questions_chi'
import { Input, FormControl, RadioGroup, FormControlLabel, Radio, CheckBox, Grid, Checkbox, TextField, Typography } from '@mui/material';
import Select from 'react-select';


function DateInputField(props) {

    const [day, setDay] = useState("")
    const [month, setMonth] = useState("")
    const [year, setYear] = useState("")

    useEffect(() => {
        const combinedDate = day + "-" + month + "-" + year

        if (day || month || year) {
            props.setState({
                ...props.state,
                "date_of_birth": combinedDate
            })
        }
    }, [day, month, year])

    const handleDateChange = (e) => {
        const [, fieldIndex] = e.target.name.split("-");
        if (e.target.name === "date-1") {
            setDay(e.target.value)
        }
        if (e.target.name === "date-2") {
            setMonth(e.target.value)
        }
        if (e.target.name === "date-3") {
            setYear(e.target.value)
        }
        // Check if they hit the max character length
        if (e.target.value.length >= 2) {
            // Check if it's not the last input field
            if (parseInt(fieldIndex, 10) < 3) {
                // Get the next input field
                const nextSibling = document.querySelector(
                    `input[name=date-${parseInt(fieldIndex, 10) + 1}]`
                );
                // If found, focus the next field
                if (nextSibling !== null) {
                    nextSibling.focus();
                }
            }
        }
    }

    return (
        <Grid container
            justifyContent="center">
            <Grid item xs={2}>
                <TextField
                    type="number"
                    name="date-1"
                    placeholder="DD"
                    value={day}
                    onChange={handleDateChange}
                    inputProps={{ min: 0, style: { textAlign: 'center' } }}
                    autoFocus
                />
            </Grid>
            <Grid item xs={2}>
                <TextField
                    type="number"
                    name="date-2"
                    placeholder="MM"
                    value={month}
                    onChange={handleDateChange}
                    inputProps={{ min: 0, style: { textAlign: 'center' } }}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField
                    type="number"
                    name="date-3"
                    placeholder="YY"
                    value={year}
                    onChange={handleDateChange}
                    inputProps={{ min: 0, style: { textAlign: 'center' } }}
                />
            </Grid>
        </Grid>
    )
}

export default DateInputField